import {
  teamMasterActionsDetails,
  getTeamsDetailActionsDetails,
  getTeamsPanActions,
  getTeamsAadharActions,
} from "./action";

const initialState = {
  masterData: {},
  teamsDirectDataList: {},
  teamsPanDataList: {},
  teamsAadharDataList: {},
};

const teamsDetailMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case teamMasterActionsDetails.TEAM_DETAIL_MASTER_SUCCESS:
      return {
        ...state,
        masterData: action.payload,
      };

    case getTeamsDetailActionsDetails.GET_TEAM_DIRECTOR_DETAIL_SUCCESS:
      return {
        ...state,
        teamsDirectDataList: action.payload,
      };

    case getTeamsPanActions.GET_TEAM_PAN_DETAIL_SUCCESS:
      return {
        ...state,
        teamsPanDataList: action.payload,
      };

    case getTeamsAadharActions.GET_TEAM_AADHAR_DETAIL_SUCCESS:
      return {
        ...state,
        teamsAadharDataList: action.payload,
      };

    case getTeamsAadharActions.GET_TEAM_AADHAR_DETAIL_ERROR:
      return {
        ...state,
        teamsAadharDataList: action.payload,
      };
    default:
      return state;
  }
};

export default teamsDetailMasterReducer;
